<div class="w-full bg-theme-yellow rounded-xl h-full">
  <div class="content absolute left-0 top-0 w-[100%] p-5">
    <div class="absolute sm-home:-ml-[26px] left-0 sm-home:left-55 md:left-75 lg:left-125 2xl:left-175
        top-0 w-38 2xs:w-64 h-29 bg-[url(https://media.7minutespourtoi.fr/cdn-7mnptoi-fr/assets/images/home/why/card-yellow/home-why-pink-cloud.svg)] bg-right-top bg-contain bg-no-repeat">
    </div>
    <div class="absolute left-0 w-[600px] lg:w-[824px] 2xl:w-[1024px] top-72 sm-home:top-75 2xl:top-72 2xl:-ml-15
        h-30 bg-[url(https://media.7minutespourtoi.fr/cdn-7mnptoi-fr/assets/images/home/why/card-yellow/home-why-pink-line.svg)] bg-right-bottom bg-contain bg-no-repeat">
    </div>
    <div class="absolute top-78 sm-home:top-58 2xl:top-58
        h-32 sm-home:h-52 left-4 sm-home:left-75 md:left-90 lg:left-142 2xl:left-158
        w-48 sm-home:w-35 2xl:w-70
        bg-top sm-home:bg-center 2xl:bg-top rounded-xl bg-cover bg-no-repeat
        bg-[url(https://media.7minutespourtoi.fr/cdn-7mnptoi-fr/assets/images/home/why/card-yellow/home-why-yellow-photo.webp)]">
    </div>
    <div class="absolute left-4 sm-home:left-10 top-7 2xs:top-12 w-55 xs-home:w-[260px] 2xs:w-90 lg:w-110 2xl:w-140 lg:text-2xl h-25">
      <h3 class="font-theme-source text-2xl 2xs:text-2xl lg:text-3xl text-theme-black font-bold">Les apps ont leurs limites</h3>
      <p class="font-theme-source text-sm xs-home:text-base lg:text-base text-theme-black mt-3 sm-home:mt-5 mr-0 xs:mr-2 2xs:mr-15 sm-home:mr-32 lg:mr-12">
        Sors des applications avec des personnes anonymes, le monde a besoin de contact et nos rencontres te promettent de la proximité pour que la communication
        en réel redevienne le langage de l’amour. <span class="hidden xs-home:block font-bold">Déconnecte-toi, et pars en quête de nouvelles émotions.</span>
      </p>
    </div>
  </div>
</div>
